package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.processStates.ProcessStateEntryId
import it.neckar.processStates.ProcessStatePhase
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("FinalAccountProcessStateEntry")
data class FinalAccountProcessStateEntry(
  override val id: ProcessStateEntryId,
  override val processState: FinalAccountProcessStates,
  override val assignedTo: UserLoginName,
  override val belongsTo: CompanyCode,
  override val assignedAt: IsoMillis,
  override val assignedBy: UserLoginName,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : LizergyProcessStateEntry {

  override val availableOptions: List<FinalAccountProcessStates>
    get() = FinalAccountProcessStates.entries

  override fun format(i18nConfiguration: I18nConfiguration): String {
    return processState.format(i18nConfiguration)
  }

  @Serializable
  @SerialName("FinalAccountProcessStates")
  enum class FinalAccountProcessStates : LizergyProcessStates {
    Missing,
    BeingEdited,
    Sent,
    Paid,

    ;

    override val inPhase: ProcessStatePhase
      get() = when (this) {
        Missing -> ProcessStatePhase.Untouched
        BeingEdited -> ProcessStatePhase.InProgress
        Sent -> ProcessStatePhase.Waiting
        Paid -> ProcessStatePhase.Done
      }

    override fun format(i18nConfiguration: I18nConfiguration): String {
      return when (this) {
        Missing -> "AR fehlt"
        BeingEdited -> "AR in Bearbeitung"
        Sent -> "AR gesendet"
        Paid -> "AR gezahlt"
      }
    }
  }
}
